import { render, staticRenderFns } from "./SmartDocument.vue?vue&type=template&id=78b871d6&"
import script from "./SmartDocument.vue?vue&type=script&lang=js&"
export * from "./SmartDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports